import { Component, input } from '@angular/core';
import { ComposedElement } from '@hyper-inferno/survey-elements-core-utils';
import { SafeScriptComponent } from '../script-injector/safe-script/safe-script.component';

@Component({
  selector: 'lib-element-main-text',
  imports: [SafeScriptComponent],
  templateUrl: './element-main-text.html',
  styleUrl: './element-main-text.css',
})
export class ElementMainText {
  // TODO make this Question
  question = input.required<ComposedElement>();
}
